import { useMutation } from '@apollo/react-hooks'
import * as Mutation from '../api/gql/mutation'

interface LogActivityParams {
  snagId: string
  title: string
  description?: string
}

export const useSnagActivityLogger = () => {
  const [logActivity] = useMutation(Mutation.LOG_SNAG_ACTIVITY)

  const logSnagActivity = async ({ snagId, title, description }: LogActivityParams) => {
    try {
      await logActivity({
        variables: {
          snagId,
          title,
          description,
        },
      })
    } catch (error) {
      console.error('Error logging snag activity:', error)
    }
  }

  return { logSnagActivity }
}
